<template>
  <div id="setting">
    <CameraMenu v-if="canSupportWebRTC" />
    <MicMenu v-if="canSupportWebRTC" />
    <SpeakerMenu />
    <div class="br"></div>
    <SettingMenu />
  </div>
</template>

<script>
import MicMenu from "./MicMenu";
import SpeakerMenu from "./SpeakerMenu";
import CameraMenu from "./CameraMenu";
import SettingMenu from "./SettingMenu";

export default {
  components: {
    MicMenu,
    SpeakerMenu,
    CameraMenu,
    SettingMenu
  },
  data() {
    return {
      canSupportWebRTC: BJY.auth.canSupportWebRTC(),
    };
  },
  computed: {},
  watch: {},
  methods: {},
  created() {},
  mounted() {},
  beforeDestroy() {},
};
</script>

<style lang="scss">
#setting {
  display: flex;
  align-items: center;
  .bjy-menu-mic,
  .bjy-menu-speaker,
  .bjy-menu-camera {
    margin-right: 12px;
    transform: scale(1.1);
  }
  .br {
    height: 24px;
    width: 2px;
    background: #aaa;
    margin: 0 16px 0 4px;
  }
}
</style>
